import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Fried Fish Tacos',
  source: 'https://www.seriouseats.com/crispy-fried-fish-tacos-recipe',
  totalTime: time(0, 25),
  servings: 4,
  tags: { type: 'main' },
  ingredients: [
    { name: 'cake flour', quantity: '1 1/2', unit: 'cup' },
    { name: 'paprika', quantity: '2', unit: 'tbsp' },
    { name: 'black pepper', quantity: '2', unit: 'tsp' },
    { name: 'kosher salt' },
    { name: 'beer', quantity: '3/4', unit: 'cup',
      amountNote: 'plus more as necessary',
    },
    { name: 'egg', quantity: '1' },
    { name: 'sour cream', quantity: '3/4', unit: 'cup' },
    { name: 'sriracha', quantity: '2', unit: 'tbsp' },
    { name: 'peanut oil', quantity: '2', unit: 'quart',
      fixed: true,
    },
    { name: 'white fish', quantity: '1', unit: 'lb',
      note: ['(cod, hake, halibut) cut into ', { multiply: 8 }, ' 2-ounce fingers'],
    },
    { name: 'corn tortillas', quantity: '16',
      note: 'warmed',
    },
    { name: 'cabbage', quantity: '1', unit: 'small head', customUnit: true,
      note: 'finely shredded',
    },
    { name: 'pickled red onions', quantity: '4', unit: 'servings', customUnit: true },
    { name: 'cilantro', quantity: '1/2', unit: 'cup',
      note: 'finely chopped',
    },
    { name: 'limes', quantity: '2',
      note: 'cut into wedges',
    },
  ],
  directions: [
    {
      title: 'Make batter & dredge',
      bullets: [
        "In large bowl, whisk together {cake flour}, {paprika}, {black pepper} & {kosher salt}",
        "Transfer half of mixture to large bowl & set aside",
        "Add {beer} & {egg} to remaining mixture",
        "Whisk wet mixture into smooth batter (consistency of thick paint - add up to {=1/2 cup} more beer if needed)",
      ],
    },
    {
      title: 'Mix spicy sour cream',
      bullets: [
        "In medium bowl, whisk together {sour cream} & {sriracha} until homogenous",
      ],
    },
    {
      title: 'Bread & fry fish',
      bullets: [
        "In deep fryer, heat {peanut oil} to {!350F}",
        "Transfer {white fish} pieces to bowl with batter & coat thoroughly",
        "One piece at a time, lift fish & let excess batter drip off",
        "Transfer fish to bowl with dry mixture & coat thoroughly",
        "Transfer fish with tongs or dry fingers into hot oil",
        "Fry, turning occasionally, until golden brown on all sides, about 3 minutes total",
        "Transfer to paper towel-lined plate",
        "Season with {kosher salt}",
      ],
    },
    {
      title: 'Assemble tacos',
      bullets: [
        "Divide {corn tortillas} into {=8} double stacks",
        "Top each with shredded {cabbage}, 1 piece of fish, {pickled red onions}, spicy sour cream & {cilantro}",
        "Serve with {limes}",
      ],
    },
  ],
};

export default recipe;
